var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.btnType,{tag:"component",staticClass:"tgb-button",class:_vm.variantType,attrs:{"type":_vm.type,"href":_vm.href,"to":_vm.to},on:{"click":_vm.click}},[_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }